import "../../Login.scss";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { URLS } from "../../helpers/URLS";
import useAxios from "../../helpers/Hooks/useAxios";
import NabBar from "../../components/Navbar/NabBar";
import Footer from "../../components/Footer/Footer";
import PasswordInput from "../../components/PasswordInput/PasswordInput";
import ArtActivate from "../../assets/images/art-activate.svg"
import ArtOtp from "../../assets/images/art-otp.svg"

const AccountActivate = () => {

    const navigate = useNavigate();
    const { fetchData } = useAxios();

    const [loginPayload, setLoginPayload] = useState({
        email: "",
    });

    const [vericationDetails, setVerificationDetails] = useState({
        isActive: false,
        otp: "",
        password: "",
        email: "",
        re_password: ""
    })

    // useEffect(() => {
    //     checkIsAuthenticated();
    // }, [])

    // const checkIsAuthenticated = async () => {
    //     const resp = await fetchData({ url: URLS.auth, method: "get" });
    //     if (resp.status === 200) {
    //         navigate("/dashBoard");
    //     }
    // }

    const handleChange = (e) => {
        setLoginPayload({
            ...loginPayload,
            [e.target.name]: e.target.value,
        });
    };
    const accounhandleChange = (e) => {
        setVerificationDetails({
            ...vericationDetails,
            [e.target.name]: e.target.value,
        });
    };
    
    const submitLogin = async (e) => {
        if (!e) {
            return null;
        }
        e.preventDefault();
        if (!vericationDetails.isActive) {
            if(!loginPayload.email)
            {
                toast.error("Email is required")
                return;
            }

            const resp = await fetchData({
                url: URLS.activeAccountOtpGenerate,
                method: "post",
                body: loginPayload,
            });
            if (resp.status === 200) {
                setVerificationDetails({
                    ...vericationDetails,
                    email: loginPayload.email,
                    isActive: true
                })
                toast.success(resp.message)
            }
            else {
                toast.error(resp.message)
            }
        } else {
            if(!vericationDetails.otp)
            {
                toast.error("Otp is required")
                return;
            }

            if(!vericationDetails.password)
            {
                toast.error("password is required")
                return;
            }

            if(vericationDetails.password !== vericationDetails.re_password)
            {
                toast.error("password  does not mached re-enterpassword")
                return;
            }
            const resp = await fetchData({
                url: URLS.activeAccount,
                method: "post",
                body: vericationDetails,
            });
            if (resp.status === 200) {
          
                toast.success(resp.message)
                navigate("/login");
            }
            else {
                toast.error(resp.message)
            }

        }
    }


    const isVerifying = Boolean(vericationDetails && vericationDetails.isActive);

    const step = isVerifying
        ? {
            art: ArtOtp,
            heading: "Check your inbox",
            blurb: "Enter the code we sent, then choose the password you'll sign in with.",
        }
        : {
            art: ArtActivate,
            heading: "Welcome aboard",
            blurb: "Activate your account with your work email to get started.",
        };

    return (
        <div>
            <NabBar />
            <form onSubmit={submitLogin}>
                <div id="login">
                    <div className="login-card">
                        <div className="profile">
                            <div className="profile-art">
                                <img src={step.art} className="profile-image" alt="" />
                            </div>
                            <div className="brand-copy">
                                <h3 className="brand-heading">{step.heading}</h3>
                                <p className="brand-sub">{step.blurb}</p>
                            </div>
                        </div>
                        <div className="login-details">
                            <div className="form-head">
                                <h2 className="title">Activate Account</h2>
                                <p className="subtitle">
                                    {isVerifying
                                        ? "Enter your code and set a password"
                                        : "We'll send a one-time code to your work email"}
                                </p>
                            </div>
                            {!isVerifying && (
                                <>
                                    <input type="text" value={loginPayload.email} onChange={handleChange} name="email" placeholder="email@motivitylabs.com" />
                                    <button type="submit" className="button_login">Send Code</button>
                                </>
                            )}
                            {isVerifying && (
                                <>
                                    <input autoComplete="off" onChange={accounhandleChange} type="text" value={vericationDetails.otp} name="otp" placeholder="123456" />
                                    <PasswordInput
                                        name="password"
                                        value={vericationDetails.password}
                                        onChange={accounhandleChange}
                                        placeholder="Password"
                                        autoComplete="new-password"
                                    />
                                    <PasswordInput
                                        name="re_password"
                                        value={vericationDetails.re_password}
                                        onChange={accounhandleChange}
                                        placeholder="Re-enter Password"
                                        autoComplete="new-password"
                                    />
                                    <button type="submit" className="button_login">Activate Account</button>
                                </>
                            )}
                            <button type="button" onClick={() => navigate("/login")} className="button_back">Back to Login</button>
                        </div>
                    </div>
                </div>
            </form>

            <Footer />
        </div>
    );
};

export default AccountActivate;

